// this is an autogenerated file from DesignSystem/CreateNewProfessionalModal/Addresses/AddressItem/City/Cities/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_CreateNewProfessionalModal_Addresses_AddressItem_City_Cities($search_term: String!) {
  vaxiom_contact_postal_addresses(
    where: { city: { _ilike: $search_term } }
    limit: 20
    distinct_on: city
    order_by: { city: asc }
  ) {
    id
    value: city
  }
}

`